import React, { useState, useEffect } from "react";
import "./ProductAdmin.css";
import { EyeOpenSvg } from "./EyeOpenSvg";
import { EyeClosedSvg } from "./EyeClosedSvg";
import { PencilSvg } from "./PencilSvg";
import { CheckmarkSvg } from "./CheckmarkSvg";
import { DeleteCanSvg } from "./DeleteCanSvg";
import { socket } from "../hooks/useFilteredProducts";

const ProductAdmin = ({ product }) => {
  const [isAvailable, setIsAvailable] = useState(product.disponible);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [editableProduct, setEditableProduct] = useState({
    img: product.img || "",
    nombre: product.nombre,
    precio: product.precio,
    presentacion: product.presentacion,
    peso: product.peso || 0,
    categoria: product.categoria || "verduras",
    disponible: product.disponible,
  });

  useEffect(() => {
    setIsAvailable(product.disponible);
    setEditableProduct({ ...product });
  }, [product]);

  const handleToggle = async () => {
    const newAvailability = !isAvailable;

    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend-verduleria-production.up.railway.app/api/products/${product.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            editedProduct: { ...product, disponible: newAvailability },
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error al actualizar la disponibilidad");
      }

      const updatedProduct = await response.json();
      setIsAvailable(updatedProduct.disponible);

      socket.emit("productoActualizado", updatedProduct);
    } catch (error) {
      console.error("Error al alternar disponibilidad:", error);
    }
  };

  const handleEditToggle = () => setIsEditing(!isEditing);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setIsEditing(false);

    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend-verduleria-production.up.railway.app/api/products/${product.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ editedProduct: { ...editableProduct } }),
        }
      );

      if (!response.ok) {
        throw new Error("Error al guardar los cambios del producto");
      }

      const updatedProduct = await response.json();
      setEditableProduct(updatedProduct);
      socket.emit("productoActualizado", updatedProduct);
    } catch (error) {
      console.error("Error al guardar el producto:", error);
    }
  };

  const confirmDelete = async () => {
    setShowDeletePopup(false);

    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend-verduleria-production.up.railway.app/api/products/${product.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al eliminar el producto");
      }

      socket.emit("productoEliminado", product.id);
    } catch (error) {
      console.error("Error al eliminar el producto:", error);
    }
  };

  return (
    <div
      className={`productAdmin shadow text-center ${
        !isAvailable ? "disabled" : ""
      }`}
    >
      <div
        className="product-image"
        style={{ backgroundImage: `url(${product.img})` }}
      ></div>
      <div className="product-title">{product.nombre}</div>
      <div className="product-price">
        ${product.precio} x {product.presentacion}
      </div>

      <div className="adminButton">
        <button
          className={`productEnable toggle-disable ${
            !isAvailable ? "habilitar" : "deshabilitar"
          }`}
          onClick={handleToggle}
        >
          {isAvailable ? <EyeClosedSvg /> : <EyeOpenSvg />}
        </button>
        <button className="productEdit toggle-edit" onClick={handleEditToggle}>
          {isEditing ? <CheckmarkSvg /> : <PencilSvg />}
        </button>
        <button
          className="productDelete toggle-delete"
          onClick={() => setShowDeletePopup(true)}
        >
          <DeleteCanSvg />
        </button>
      </div>

      {showDeletePopup && (
        <div className="popupOverlay">
          <div className="popupContent">
            <p>¿Seguro que deseas eliminar "{product.nombre}"?</p>
            <button onClick={confirmDelete} className="habilitar">
              Confirmar
            </button>
            <button
              onClick={() => setShowDeletePopup(false)}
              className="productDelete"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {isEditing && (
        <div className="popupOverlay">
          <div className="popupContent">
            <button className="closeButton" onClick={() => setIsEditing(false)}>
              ✕
            </button>
            <h3>Editar Producto</h3>
            <form>
              <label>
                Imagen Url:
                <input
                  type="text"
                  name="img"
                  value={editableProduct.img}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Nombre:
                <input
                  type="text"
                  name="nombre"
                  value={editableProduct.nombre}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Precio:
                <input
                  type="number"
                  name="precio"
                  value={editableProduct.precio}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Presentación:
                <input
                  type="text"
                  name="presentacion"
                  value={editableProduct.presentacion}
                  onChange={handleInputChange}
                  required
                />
              </label>
              <label>
                Peso:
                <input
                  type="number"
                  name="peso"
                  value={editableProduct.peso}
                  onChange={handleInputChange}
                />
              </label>
              <label>
                Categoría:
                <select
                  name="categoria"
                  value={editableProduct.categoria}
                  onChange={handleInputChange}
                >
                  <option value="verdura">Verdura</option>
                  <option value="fruta">Fruta</option>
                  <option value="envasados">Envasados</option>
                  <option value="mayorista">Mayorista</option>
                </select>
              </label>
              <button type="button" onClick={handleSave}>
                Guardar
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductAdmin;
